import React, { useState } from "react";
import { Link } from "react-router-dom";
import useLogout from "../../../hooks/useLogout";

const NavList = ({ navigationList }) => {
  const logoutUser = useLogout();
  const logout = async () => {
    const response = await logoutUser();
  };

  const fullPath = window.location.pathname; // "/customerProfile/7687"
  const path = fullPath.split('/').slice(0, -1).join('/') + '/'; // "/customerProfile/"

  const [showNextLevelNav, setshowNextLevelNav] = useState({});
  return (
    <>
      {navigationList !=undefined &&
        navigationList.map((item) => {
        return (

          <li
            className={
              item.link_url === window.location.pathname || (item.link_url === "/customers" && window.location.pathname=="/addCustomer") || (item.link_url === "/customers" && path=="/customerProfile/") ? "active" : ""
            }
            key={item.link_name}
          >
            {item.sub_links ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setshowNextLevelNav({
                    ...showNextLevelNav,
                    [item.link_name]: !showNextLevelNav[item.link_name],
                  });
                }}
              >
                {item.link_name}
                {showNextLevelNav[item.link_name] ? " -" : " +"}
              </span>
            ) : (
              <Link to={item.link_url}>
                <i className="material-symbols-rounded mt-m white">
                  {item.menu_icon_tag}
                </i>
                {item.link_name}
              </Link>
            )}
            {showNextLevelNav[item.link_name] && item.sub_links && (
              <NavList navigationList={item.sub_links} />
            )}
          </li>
        );
      })}
    </>
  );
};

export default NavList;
